var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.07 32.67c1.88 7.86 10 14.9 10 21.76a10 10 0 01-20 0c0-6.87 8.13-13.91 10-21.76zm21.86-21.34c-1.88 7.86-10 14.9-10 21.76a10 10 0 0020 0c0-6.86-8.13-13.9-10-21.76z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Humidity.7f6beb4e.svg";
export { SvgBzHumidity as ReactComponent };